import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

class ElementSize extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      width: null,
      height: null
    });
    _defineProperty(this, "_node", null);
    // eslint-disable-next-line react/sort-comp
    _defineProperty(this, "setDimensions", () => {
      if (this._node) {
        // Prevents unhandled exception: `Uncaught TypeError: Cannot read property 'clientHeight' of null`
        this.setState({
          height: this._node.clientHeight,
          width: this._node.clientWidth
        });
      }
    });
    _defineProperty(this, "setRef", element => {
      this._node = element;
    });
    _defineProperty(this, "onResize", debounce(this.setDimensions, 200));
  }
  componentDidMount() {
    // DOM is hard
    // TODO: find better hack

    // without the setTimeout the dimensions are calculated
    // inaccurately b/c its still rendering

    // this first timeout sets it "close" but is still not
    // always accurate
    setTimeout(this.setDimensions);

    // this updates it again to be more sure its accurate
    setTimeout(this.setDimensions, 200);
    window.addEventListener("resize", this.onResize);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      ref: this.setRef
    }, children(this.state));
  }
}
ElementSize.displayName = "ElementSize";
_defineProperty(ElementSize, "propTypes", {
  children: PropTypes.func.isRequired
});

export { ElementSize as default };
